import React from "react";
import { jobsData } from "../WhatWeDo/jobsData";
import { Link } from "react-router-dom";

const projectBasedData = [
  {
    service: "Painting",
    rate: "$1.50/sq ft",
    notes: "Customer provides paint",
  },
  {
    service: "Tile Flooring",
    rate: "$5.50/sq ft",
    notes: "Labor only — materials not included",
  },
  {
    service: "LVP Flooring",
    rate: "$3.50/sq ft",
    notes: "Includes underlayment install",
  },
];

const Pricing = ({ handleScheduleClick }) => {
  return (
    <div className="with-navbar-offset pricing-main-bg">
      {/* Top Bar */}
      <div className="top-bar-wrapper enhanced-top-bar">
        <div className="container">
          <div className="row">
            <div className="col-12 top-bar-info-main enhanced-top-bar-info">
              <span className="lincensed-para enhanced-top-bar-text">
                ⭐ Not a licensed contractor
              </span>
            </div>
          </div>
        </div>
      </div>
      {/* Hero Section */}
      <section className="pricing-hero-section">
        <div className="container pricing-hero-row">
          <div className="pricing-hero-col-left">
            <h1 className="section-title pricing-hero-title">
              Pricing: Clear. Fair. No Surprises.
            </h1>
            <div className="section-subtitle pricing-hero-subtitle">
              Right Now: Get Our Lowest Rates in Years
            </div>
            <div className="pricing-sale-banner">
              To celebrate our anniversary — and help out during these uncertain
              times — we've dropped our hourly pricing for a limited time:
              <div className="pricing-sale-row">
                <span className="pricing-sale-main">First Hour: $79</span>
                <span className="pricing-sale-divider">|</span>
                <span className="pricing-sale-main">
                  Each Additional Hour: $69
                </span>
                <span className="pricing-sale-normal">(Normally $79)</span>
              </div>
              <div className="pricing-sale-note">
                📌 Sale ends soon — book now to lock in the rate.
              </div>
            </div>
            <div className="pricing-hero-desc">
              No hidden fees. No payment until you're happy. All pricing is
              clear and up front.
            </div>
          </div>
          <div className="pricing-hero-col-right">
            <div className="alex-chat-bubble pricing-chat-cta">
              <div className="alex-chat-icon">💬</div>
              <div className="alex-chat-content">
                <div className="alex-chat-title">
                  Need a Quote Fast? Ask Alex.
                </div>
                <div className="alex-chat-desc">
                  Our smart assistant can estimate, schedule, and confirm most
                  jobs — 24/7.
                </div>
                <div className="pricing-chat-btn-row">
                  <button
                    className="ctaButton chat-button"
                    onClick={handleScheduleClick}
                    type="button"
                  >
                    <span className="icon" role="img" aria-label="chat">
                      👉
                    </span>{" "}
                    Chat Now
                  </button>
                  <a href="tel:9168859447" className="ctaButton secondary">
                    <span className="icon" role="img" aria-label="phone">
                      📞
                    </span>{" "}
                    Call
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Main Content Two-Column Section */}
      <section className="pricing-main-section">
        <div className="container pricing-main-row">
          {/* Left Column */}
          <div className="pricing-main-col-left">
            <h2 className="section-title pricing-main-title">
              <span role="img" aria-label="check">
                ✅
              </span>{" "}
              What's Included
            </h2>
            <ul className="pricing-features">
              <li>
                <span className="check">✔️</span> Licensed, vetted, full-time
                professional handyman
              </li>
              <li>
                <span className="check">✔️</span> Arrival at a real appointment
                time (not a vague window)
              </li>
              <li>
                <span className="check">✔️</span> Clear expectations and pricing
                before work begins
              </li>
              <li>
                <span className="check">✔️</span> No material markup — ever
              </li>
              <li>
                <span className="check">✔️</span> Payment only after you're
                satisfied
              </li>
            </ul>
            <h2 className="section-title pricing-main-title pricing-main-dont">
              <span role="img" aria-label="warning">
                ⚠️
              </span>{" "}
              What We Don't Do
            </h2>
            <ul className="pricing-features pricing-dont-list">
              <li>🚫 No deposits</li>
              <li>🚫 No junk fees</li>
              <li>🚫 No vague quotes</li>
              <li>🚫 No payment until you're satisfied</li>
            </ul>
            <div className="pricing-main-note">
              We'll always explain what to expect — and if a job might run long,
              you'll know in advance.
            </div>
          </div>
          {/* Right Column */}
          <div className="pricing-main-col-right">
            <div className="pricing-card">
              <h2 className="section-title pricing-main-title">
                <span role="img" aria-label="money">
                  💲
                </span>{" "}
                Hourly Pricing
              </h2>
              <div className="pricing-hourly-card">
                <div className="pricing-hourly-row">
                  <span className="pricing-hourly-main">First Hour: $79</span>
                </div>
                <div className="pricing-hourly-row">
                  <span className="pricing-hourly-main">
                    Each Additional Hour: $69
                  </span>
                  <span className="pricing-hourly-normal">(Normally $79)</span>
                </div>
                <div className="pricing-hourly-note">
                  📌 Sale ends soon — book now to lock in the rate.
                </div>
              </div>
              <h2 className="section-title pricing-main-title">
                <span role="img" aria-label="paint">
                  🎨
                </span>{" "}
                Project-Based Pricing (Per Sq Ft)
              </h2>
              <table className="jobs-table pricing-project-table">
                <thead>
                  <tr>
                    <th>Service</th>
                    <th>Labor Rate</th>
                    <th>Notes</th>
                  </tr>
                </thead>
                <tbody>
                  {projectBasedData.map((row, idx) => (
                    <tr key={idx}>
                      <td>{row.service}</td>
                      <td>{row.rate}</td>
                      <td>{row.notes}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <h2 className="section-title pricing-main-title">
                <span role="img" aria-label="cart">
                  🛒
                </span>{" "}
                Need Materials Picked Up?
              </h2>
              <div className="specialty-note pricing-store-note">
                Store Time Add-On:{" "}
                <span className="pricing-store-bold">+1 Hour of labor</span>
                <br />
                <span className="pricing-store-desc">
                  Covers driving, shopping, loading, and returning with what's
                  needed.
                </span>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Pricing Example Table (Full Width) */}
      <section className="pricing-example-section">
        <div className="container">
          <h2 className="section-title pricing-example-title">
            <span role="img" aria-label="toolbox">
              🧰
            </span>{" "}
            Pricing Example: Real Jobs with Real Estimates
          </h2>
          <div className="jobs-table-wrapper">
            <table className="jobs-table pricing-example-table">
              <thead>
                <tr>
                  <th>Service</th>
                  <th>Avg Time</th>
                  <th>Est. Labor Cost</th>
                  <th>Notes</th>
                </tr>
              </thead>
              <tbody>
                {[
                  jobsData.find((j) => j.service.includes("TV Mounting")),
                  jobsData.find((j) => j.service.includes("Ceiling Fan")),
                  jobsData.find((j) =>
                    j.service.toLowerCase().includes("toilet")
                  ),
                  jobsData.find((j) =>
                    j.service.toLowerCase().includes("furniture")
                  ),
                  jobsData.find((j) => j.service.toLowerCase().includes("bbq")),
                  jobsData.find((j) =>
                    j.service.toLowerCase().includes("pergola")
                  ) || {
                    service: "Pergola Build",
                    avgTime: "Half–Full Day",
                    estPrice: "$400–$800+",
                    notes: "Crew size & kit complexity vary",
                  },
                ].map(
                  (job, idx) =>
                    job && (
                      <tr key={idx}>
                        <td>{job.service}</td>
                        <td>{job.avgTime}</td>
                        <td>{job.estPrice}</td>
                        <td>{job.notes}</td>
                      </tr>
                    )
                )}
              </tbody>
            </table>
          </div>
          <div className="pricing-example-link-row">
            Want full pricing on over 36 common jobs?{" "}
            <Link
              to="/what-we-do"
              className="yellow-button pricing-example-link"
            >
              👉 See Our Top Services Page
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Pricing;
